const binding = { modules: {}, dataActions: {} };

    (binding.modules['footer-section'] = {
        c: () => require('partner/modules/footer-section/footer-section.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'footer-section',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/footer-section'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|footer-section|footer-section'] = {
                c: () => require('partner/modules/footer-section/footer-section.view.tsx'),
                cn: '__local__-__local__-footer-section'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };